import * as React from "react";
import ResizeObserver from "resize-observer-polyfill";

function getSize(el: HTMLElement | null) {
  if (!el) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: el.offsetWidth,
    height: el.offsetHeight
  };
}

export default function useComponentSize(ref: React.RefObject<HTMLElement>) {
  var _useState = React.useState(getSize(ref ? ref.current : null));
  var ComponentSize = _useState[0];
  var setComponentSize = _useState[1];

  var handleResize = React.useCallback(() => {
    if (ref.current) {
      setComponentSize(getSize(ref.current));
    }
  }, [ref]);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    handleResize();

    var resizeObserver = new ResizeObserver(handleResize);

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current]);

  return ComponentSize;
}
